import axios from "../axios-init";

export const getServiceFeeList = params => {
    return axios.post(`/serviceFee/getServiceFeeList`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const editServiceFee = params => {
    return axios.post(`/serviceFee/saveOrUpdateById`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getServiceFeeById = params => {
    return axios.post(`/serviceFee/getServiceFeeById`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};



// WEBPACK FOOTER //
// ./src/api/serviceFeeService.js